module.exports = __webpack_public_path__ + "img/chat-document.64b950b6.png";